// TTL da reserva no backend (config('order.reserved_batch_timeout'), default
// 1200s). Só vale se a resposta do POST /orders/ não trouxer `expires_in`.
export const DEFAULT_RESERVATION_SECONDS = 20 * 60;

/**
 * Quando a reserva do pedido acaba, em epoch ms do navegador. Conta a partir
 * da resposta do POST /orders/ com o `expires_in` que a API mandou — e não
 * pelo `expires_at`, que dependeria do relógio do computador estar certo.
 */
export function reservationEndsAt(orderResponse) {
    const seconds = Number(orderResponse?.expires_in);

    return Date.now() + (seconds > 0 ? seconds : DEFAULT_RESERVATION_SECONDS) * 1000;
}
